import React, {CSSProperties, memo} from 'react'
import {DropdownInput} from "atmosfair-ui";
import {convertCountriesFromDropdownFormat, convertCountriesToDropdownFormat,} from "../../utils/converter/dropdown";
import {COUNTRY_NAMES_FOR_DROPDOWN, defaultCountriesForTop} from "../../constants/default-values";
import {allCountryNames, CountryProps} from "../../components/settings/utils";

export interface CountriesDropdownProps {
    error: boolean,
    setSelection: (value: string | null) => void,
    country?: CountryProps | string | null,
    style?: CSSProperties,
    required: boolean,
    readOnly?: boolean,
}

const CountriesDropdown = memo(function CountriesDropdown({
                                                              error,
                                                              setSelection,
                                                              country,
                                                              style,
                                                              required,
                                                              readOnly,
                                                          }: CountriesDropdownProps) {
    const _getCountryFromCountryStringForDropdown = (country: string | null): CountryProps | null => convertCountriesFromDropdownFormat(
        convertCountriesToDropdownFormat(allCountryNames)
            .filter(countryObject => countryObject.raw.name.toLowerCase() === country?.toLowerCase())
    )

    const _convertCountry = () => {
        if (typeof country === "string") return _getCountryFromCountryStringForDropdown(country)?.id ?? null
        return country?.id ? country.id : null
    }

    return <DropdownInput
        readOnly={readOnly}
        defaultValue={_convertCountry()}
        aria-errormessage={"ERRORS.COMMON.COUNTRY"}
        formError={error}
        containerStyle={style}
        required={required}
        label={"GENERAL.COUNTRY_LABEL"}
        showOnTop={defaultCountriesForTop()}
        options={COUNTRY_NAMES_FOR_DROPDOWN}
        setSelection={selection => setSelection(convertCountriesFromDropdownFormat(selection)?.name ?? null)}/>
})

export default CountriesDropdown